import { useEffect } from 'react';

const DEFAULT_TITLE = 'Gift Request Manager';

/** DL-448: one shared rule for every screen's browser tab title, replacing several
 * independently-drifted `document.title` effects (differing formats and fallback strings). */
export function useDocumentTitle(orgName: string | null | undefined, context: string) {
	useEffect(() => {
		document.title = orgName ? `${orgName} | ${context}` : DEFAULT_TITLE;
	}, [orgName, context]);
}
